<template>
  <div>
    <alert :shown="showAlert" :title="alertTitle" :type="alertType" :content="alertContent" />
    <h1>Preferences</h1>
    <div class="register-wrapper">
      <h2>Personal preferences</h2>
      <div id="registerNew">
        <form class="panel" v-on:submit.prevent="updateUser">
          <div class="panel-body">
            <div class="form-group">
              <label class="form-label" for="username2">Username</label>
              <input class="form-input" type="text" id="username2" disabled v-model="username" />
            </div>
            <div class="form-group">
              <label class="form-label" for="firstname">First name</label>
              <input class="form-input" type="text" id="firstname" v-model="me.firstname" />
            </div>
            <div class="form-group">
              <label class="form-label" for="lastname">Last name</label>
              <input class="form-input" type="text" id="lastname" v-model="me.lastname" />
            </div>
            <div class="form-group">
              <label class="form-label" for="email">Email</label>
              <input class="form-input" type="email" id="email" v-model="me.email" />
            </div>
            <div class="form-group">
              <label class="form-label" for="birthyear">Birth year</label>
              <input class="form-input" type="number" id="birthyear" v-model="me.birthyear" />
            </div>
            <!-- Role -->
            <div class="form-group">
              <label class="form-label" for="role">Role:</label>
              <select class="form-select" id="role" v-model="me.role" disabled>
                <option value="fencer">Fencer</option>
                <option value="coach">Coach</option>
                <!-- <option value="parent">Parent</option> -->
              </select>
            </div>
            <div class="form-group">
              <label class="form-label" for="club">Club</label>
              <select class="form-select" id="club" v-model="club">
                <option value="">Choose a club</option>
                <option v-for="club in clubs" :value="club.id">
                  {{club.name}}
                </option>
              </select>
            </div>
            <div class="form-group">
              <label class="form-label" for="club2">Secondary Club</label>
              <select class="form-select" id="club2" v-model="club2">
                <option value="">Choose a club</option>
                <option v-for="club in clubs" :value="club.id">
                  {{club.name}}
                </option>
              </select>
            </div>
            <div class="form-group">
              <label class="form-label" for="weapon">Weapon</label>
              <select class="form-select" id="weapon" v-model="weapon" multiple>
                <option value="epee">Epee</option>
                <option value="foil">Foil</option>
                <option value="sabre">Sabre</option>
              </select>
            </div>
          </div>
          <div class="panel-footer">
            <button class="btn btn-primary" type="submit">Update User</button>
          </div>
        </form>
      </div>
    </div>
    <div class="passwordWrapper">
      <h2>Change your password</h2>
      <form class="panel" v-on:submit.prevent="updatePassword">
        <div class="panel-body">
          <div class="form-group">
            <label class="form-label" for="password1">Original Password*</label>
            <input class="form-input" type="password" id="password1" required v-model="oldPassword" />
          </div>
          <div class="form-group">
            <label class="form-label" for="password2">Password*</label>
            <input class="form-input" type="password" id="password2" required v-model="passwordNew" />
          </div>
          <div class="form-group">
            <label class="form-label" for="password3">Re-enter Password*</label>
            <input class="form-input" type="password" id="password3" required v-model="passwordNew2" />
            <p v-bind:style="{ display : passwordsMatch() }" class="form-input-hint">Passwords don't match!!</p>
          </div>
        </div>
        <div class="panel-footer">
          <button class="btn btn-primary" type="submit">Update Passwords</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import config from "../config.js"
  import alert from "../components/Alert"
  import { EventBus } from '../main'

  export default {
    name : "preferencesPage",
    components : {
      alert
    },
    data(){
      return {
        me : {},
        weapon : [],
        clubs : [],
        club : "",
        club2 : "",
        showAlert : "",
        alertTitle : "",
        alertType : "",
        alertContent : "",
        username : "",
        oldPassword : "",
        passwordNew : "",
        passwordNew2 : "",
        passwordsMatch : function(){
          return this.passwordNew == this.passwordNew2 ? "none" : "block"
        },
      }
    },
    methods : {
      getData : function(){
        return new Promise((resolve, reject) => {
          fetch(config.baseUrl+"user/me/", {
            credentials : "include"
          }).then(e => {
            return e.json()
          }).then(j => {
            fetch(config.baseUrl+"clubs/", {
              credenials : "include"
            }).then(e => {
              return e.json()
            }).then(j2 => {
              this.setData(j, j2)
              resolve()
            })
          })
        })
      },
      setData : function(j, j2){
        this.me = j
        this.username = this.me.username
        this.weapon = this.me.weapon
        this.club = this.me.club.id
        this.club2 = this.me.club2 ? this.me.club2.id : ""
        this.clubs = j2
      },
      render : function(){
        this.getData()
        .then(() => {
          // done
        })
      },
      updateUser : function(e){
        this.me.club = this.club
        this.me.club2  = this.club2
        this.me.weapon = this.weapon.join(",")
        delete this.me.notificationCount
        delete this.me.isOwner
        delete this.me.username
        fetch(config.baseUrl+"user/update/", {
          method: "PUT",
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          credentials: "include",
          body: JSON.stringify(this.me)
        }).then(e => {
          this.alertType = "success"
          this.alertTitle = "Preferences updated"
          this.alertContent = "Your preferences were updated successfully!"
          this.showAlert = "shown"
        }).catch(err => {

        })
      },
      updatePassword : function(e){
        if(this.passwordsMatch() == "none"){
          // they match, go ahead and update
          fetch(config.baseUrl+"user/password/update", {
            method : "PUT",
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            credentials: "include",
            body: JSON.stringify({
              oldPassword : this.oldPassword,
              newPassword : this.passwordNew
            })
          }).then(e => {
            return e.json()
          }).then(e => {
            if(e.error){
              this.alertType = "error"
              this.alertTitle = "Password not updated"
              this.alertContent = e.error
              this.showAlert = "shown"
            } else {
              this.alertType = "success"
              this.alertTitle = "Password successfully updated"
              this.alertContent = "Your password was updated successfully!"
              this.showAlert = "shown"

              this.oldPassword = ""
              this.passwordNew = ""
              this.passwordNew2 = ""
            }
          })
        } else {
          // they don't match... don't do anything
        }
      }
    },
    created(){
      this.render()

      EventBus.$on("hideAlert", () => {
        this.showAlert = ""
      })
    }
  }
</script>

<style lang="scss">
  .register-wrapper,
  .passwordWrapper {
    max-width: 700px;
  }
  .passwordWrapper {
    margin-top: 50px;
    margin-bottom: 50px;
  }
</style>
